import { RelatedLocation } from '@/components/organisms/TopTreatmentLocations/TopTreatmentLocations'
import { IndexType } from '@/domain/seo/constants'
import { LOCATION_TYPE } from '@/domain/location/constants'

const MIN_LOCATION_COUNT = 10

export const shouldIncludeHref = (
  location: RelatedLocation,
  indexType: IndexType
): boolean => {
  return (
    (indexType === IndexType.NO_CITY_FACET &&
      [LOCATION_TYPE.REGION, LOCATION_TYPE.COUNTRY].includes(location.type) &&
      location.count >= MIN_LOCATION_COUNT) ||
    (indexType === IndexType.REGION_FACET_ONLY &&
      location.type === LOCATION_TYPE.REGION &&
      location.count >= MIN_LOCATION_COUNT) ||
    (indexType === IndexType.COUNTRY_FACET_ONLY &&
      location.type === LOCATION_TYPE.COUNTRY &&
      location.count >= MIN_LOCATION_COUNT) ||
    (indexType === IndexType.FULL_INDEX && location.count >= MIN_LOCATION_COUNT)
  )
}
